import './app.css';
import {analyticsEvent} from './js/analytics';
import * as basicScroll from 'basicscroll';
//import { gsap } from "gsap";
import inView from 'in-view';
import Swiper from 'swiper';
//require('./js/top100.js');
// import { gsap } from 'gsap';
// import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js';
// gsap.registerPlugin(ScrollToPlugin);
// console.log(ScrollToPlugin);
/* is production */
// const isProd = process.env.NODE_ENV === 'production';

/* analytics (EXAMPLE: analyticsEvent('Button', 'click', 'Play');) */
/* <button data-event="click" data-event-category="Button" data-event-label="Play"> */
analyticsEvent();

// /* service worker */
// if ('serviceWorker' in navigator && isProd) {
//     import(/* webpackPrefetch: true */ './js/sw').then(func => {
//         func.default();
//     });
// }

/* lazy loading (https://github.com/verlok/lazyload) */
if (document.querySelector('.lazy') !== null) {
    import(/* webpackPrefetch: true */ './js/lazyloading').then(func => {
        func.default();
    });
}

/* share buttons */
if (document.querySelector('.share') !== null) {
    import(/* webpackPrefetch: true */ './js/share').then(func => {
        func.default();
    });
}

window.onload = function() {
    let scrollToSection = event => {
        let target = event.target,
            aim = document.querySelector(target.getAttribute('href')),
            aimChar = aim.getBoundingClientRect();
        window.scrollTo({
            top: aimChar.y + window.pageYOffset
        });
    };

    let speackersWr = document.querySelector('.intro__speackers');
    speackersWr.addEventListener('click', function(e) {
        e.preventDefault();
        if (e.target.classList.contains('speacker')) {
            scrollToSection(e);
        }
    });

    let nextBtn = document.querySelectorAll('.next');
    nextBtn.forEach(item => {
        item.addEventListener('click', function(e) {
            e.preventDefault();
            scrollToSection(e);
        });
    });

    let buttons = document.querySelectorAll('.feature__btn');
    buttons.forEach(function(item) {
        item.addEventListener('click', e => {
            e.preventDefault();
            if (!e.target.classList.contains('active')) {
                e.target.classList.add('active');
                let feature = item.closest('.feature');
                feature.querySelector('.feature__animate').classList.add('active');
                feature.querySelector('.feature__text-wrp').classList.add('active');
            } else {
                e.target.classList.remove('active');
                let feature = item.closest('.feature');
                feature.querySelector('.feature__animate').classList.remove('active');
                feature.querySelector('.feature__text-wrp').classList.remove('active');
            }
        });
    });

    let featureImgs = document.querySelectorAll('.feature__ill');
    let instances = [];

    featureImgs.forEach(item => {
        let instance = basicScroll.create({
            elem: item,
            from: 'top-bottom',
            to: 'bottom-top',
            direct: true,
            props: {
                '--transform': {
                    from: 0,
                    to: 1
                }
            }
        });
        instances.push(instance);
    });
    instances.forEach(item => {
        item.start();
    });
    inView.offset({
        top: 0,
        bottom: 50
    });

    if (window.innerWidth <= 768) {
        document.querySelectorAll('.hidden').forEach(function(el) {
            el.classList.remove('hidden');
        });
    } else if (window.innerWidth >= 768) {
        inView('.hidden').on('enter', el => {
            el.classList.remove('hidden');
        });
    }

    /*inView('.next')
        .on('enter', el => {
            el.classList.add('animated');
        })
        .on('exit', el => {
            el.classList.remove('animated');
        });*/

    /* lenta menu */
    {
        const menuButton = document.querySelector('.sidebar-button');
        //const rootElem = document.querySelector('.lenta');

        menuButton.addEventListener('click', () => {
            document.querySelector('.sidebar').classList.toggle('show');
        });
    }

    let mySwiper = new Swiper('.swiper-container', {
        init: false,
        slidesPerView: 1,
        centeredSlides: true,
        grabCursor: true,
        pagination: {
            el: '.swiper-pagination'
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        on: {
            slideChange() {
                let speackers = document.querySelectorAll('.speacker'),
                    href = speackers[this.activeIndex].getAttribute('href'),
                    container = speackers[this.activeIndex].closest('.first-screen');
                container.querySelector('.next').setAttribute('href', href);
            }
        }
    });

    function swiperInit() {
        if (window.innerWidth <= 768 && !mySwiper.initialized) {
            mySwiper.init();
        } else if (window.innerWidth >= 768 && mySwiper.initialized) {
            mySwiper.destroy();
        }
    }

    swiperInit();
    (function() {
        window.addEventListener('resize', resizeThrottler, false);
        var resizeTimeout;
        function resizeThrottler() {
            if (!resizeTimeout) {
                resizeTimeout = setTimeout(function() {
                    resizeTimeout = null;
                    swiperInit();
                }, 66);
            }
        }
    })();
    let showBtns = document.querySelectorAll('.feature__btn');
    showBtns.forEach(item => {
        item.addEventListener('click', function() {
            analyticsEvent('Button', 'click', 'Play');
        });
    });
};
